<script setup lang="ts">
import { Close } from '@element-plus/icons-vue';

const router = useRouter();

const routePath = computed(() => router.currentRoute.value.path);

let isDisplayToast = ref(true);
let isHomepage = ref(false);

watch(routePath, (value) => {
	if (value === '/' || value === '/products') {
		isHomepage.value = true;
	} else {
		isHomepage.value = false;
	}
});

onMounted(() => {
	if (routePath.value === '/' || routePath.value === '/products') {
		isHomepage.value = true;
	} else {
		isHomepage.value = false;
	}
});

const toggleToast = () => {
	isDisplayToast.value = false;
};
</script>

<template>
	<div v-if="isDisplayToast && isHomepage" class="toast-container">
		<div class="toast-margin">
			<div class="wrap-toast">
				<div class="wrap-message">
					<img class="bell-icon" src="/images/icon-notification.png" alt="Bell" width="20" height="20" />
					<span class="message">
						<span>{{ $t('changeDomainToast.part1') }}</span>
						<span
							><b>{{ $t('changeDomainToast.part2') }}</b></span
						>
						<span>{{ $t('changeDomainToast.part3') }}</span>
					</span>
				</div>

				<el-icon class="icon-close-custom" @click="toggleToast()"><Close /></el-icon>
			</div>
		</div>
	</div>
</template>

<style lang="scss" scoped>
.toast-container {
	position: absolute;
	left: 0;
	width: 100%;
	margin-top: 16px;
	align-items: center;
	box-sizing: border-box;
	display: flex;
	justify-content: center;
	.toast-margin {
		margin: 0px 16px;
		max-width: 1096px;
		width: 100%;
		.wrap-toast {
			height: 45px;
			margin-top: 59px;
			line-height: 45px;
			width: auto;
			margin: 0px;
			background: #dbebfa;
			color: #1e75cd;
			padding: 12.5px 16px;
			border-radius: 8px;
			border: 2px solid #67a8e9;
			font-size: 14px;
			display: flex;
			align-items: center;
			justify-content: space-between;
			gap: 15px;

			.wrap-message {
				display: flex;
				gap: 10px;
				align-items: center;

				.message {
					span {
						display: inline-block;
						& + span {
							margin-left: 2px;
						}
						&:nth-child(2) {
							font-weight: bold;
						}
					}
				}
			}

			a {
				color: #1e75cd;
			}
			.notification-icon {
				width: 20px;
				height: 20px;
				display: block;
			}

			.icon-close-custom {
				font-weight: bold;
				cursor: pointer;
				font-size: 15px;
			}
		}
	}
}

@media screen and (max-width: 1280px) {
	.toast-container {
		margin: 1px 0px 0px 0px;
		width: 100%;

		.toast-margin {
			margin: 0px;
			.wrap-toast {
				border-radius: 0px;
				border: none;
				height: auto;
				line-height: normal;
				box-shadow: 0px 0px 8px 0px rgba(17, 12, 34, 0.1);

				.wrap-message {
					align-items: flex-start !important;
				}
			}
		}
	}
}

@media screen and (max-width: 768px) {
	.toast-container {
		.toast-margin {
			.wrap-toast {
				display: flex !important;
				align-items: flex-start !important;
			}
		}
	}
}
</style>
